import styled from "styled-components"
import { useRef, useEffect, useState } from 'react'

import type {
    TUpload,
    TOneDriveResponse,
    TDropBoxResponse,
    TCloudButton,
    TPossibleExtensions,
    TGoogleAuthResult,
} from "../types"

import {
    filesUpload,
    onedriveUpload,
    dropboxUpload,
    gdriveUpload,
} from '../Services'

import { getMimeFromExt } from "../helpers"

// ICONS 
import dropboxIcon from '../../assets/upload-dropbox.svg'
import onedriveIcon from '../../assets/upload-onedrive.svg'
// import googledriveIcon from '../../assets/upload-gdrive.svg'
import googledriveIcon from '../../assets/upload-gdrive.svg'
import addIcon from '../../assets/upload-add.svg'
import resetIcon from '../../assets/upload-reset.svg'

declare var window: any


export const Buttons = styled.div.attrs({
    className: 'app-buttons'
})``

export const PagePreviwButtons = styled.div`
    width: 100%;
    margin-top: 12px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center
`

export const PagePreviwButton = styled.button<{
    primary: boolean,
}>`
    width: 160px;
    height: 44px;
    margin: 0 12px 0 0;

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${props => props.primary ? '#FC531B' : '#FFF'};
    border-radius: 8px;
    border: none;

    color: ${props => props.primary ? '#FFFFFF' : '#606A6C'};
    font-style: normal;
    font-weight: ${props => props.primary ? '700' : '500'};
    font-size: 18px;
    line-height: 21px;

    transition: background 0.2s ease 0s, box-shadow 0.2s ease 0s;
    cursor: pointer;
    z-index: 1;

    &:disabled {
        background: #F2F2F2;
        color: #C9CECF;
        
        cursor: default;
    }

    &:not(:disabled):hover {
        background: ${props => props.primary ? '#FF6D3D' : '#FFF'};
        border: ${props => props.primary ? '1px solid #c4390b' : '1px solid #D9D9D9'};
        /**focus: ${props => props.primary ? 'box-shadow: 0 0 0 4px hsla(20, 100%, 47%, 0.40);' : 'box-shadow: 0 0 0 4px hsla(20, 100%, 47%, 0.40);'};*/
        /**box-shadow: 0px 12px 20px rgba(0, 108, 130, 0.36);*/
        /**border: 1px solid #c4390b;*/
    }


    &:not(:disabled):active {
        background: ${props => props.primary ? '#EA4C18' : '#FFF'};
        
    }

    &:last-child {
        margin: 0;
    }

    @media screen and (max-width: 1200px) {
        width: 140px;
        margin: 0 12px 0 0;
    }

    @media screen and (max-width: 960px) {
        width: calc(140 / 640 * 100vw);
        height: calc(44 / 640 * 100vw);
        margin: 0 calc(20 / 640 * 100vw) 0 0;

        border-radius: calc(8 / 640 * 100vw);
        font-size: calc(18 / 640 * 100vw);
        line-height: calc(21 / 640 * 100vw);
    }

    @media screen and (max-width: 640px) {
        width: calc(140 / 480 * 100vw);
        height: calc(44 / 480 * 100vw);
        margin: 0 calc(20 / 480 * 100vw) 0 0;

        border-radius: calc(8 / 480 * 100vw);
        font-size: calc(18 / 480 * 100vw);
        line-height: calc(21 / 480 * 100vw);
    }

    @media screen and (max-width: 480px) {
        width: calc(140 / 320 * 100vw);
        height: calc(44 / 320 * 100vw);
        margin: 0 calc(20 / 320 * 100vw) 0 0;

        border-radius: calc(8 / 320 * 100vw);
        font-size: calc(18 / 320 * 100vw);
        line-height: calc(21 / 320 * 100vw);
    }
`

export const UploadButtons = styled.div.attrs({
    className: 'app-upload-buttons'
})``

export const CloudButtons = styled.div.attrs({
    className: 'app-cloub-buttons'
})``

export const ActionButtons = styled.div`
    width: 100%;
    margin-top: 12px;

    display: flex;
    flex-direction: row;
    justify-content: center;

    @media screen and (max-width: 640px) {
        margin: 0 0 40px;
    }

    @media screen and (max-width: 319px) {
        margin: 8px 0 40px;
    }
`

export const ButtonAction = styled.button`
    padding: 12px 0;
    width: 360px;
    

    background: #FC531B;
    border-radius: 8px;
    
    border: 1px solid #c4390b;

    color: #FFFFFF;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    transition: background .3s;
    cursor: pointer;
    z-index: 1;

    &:hover {
        background: #FF6D3D;
    }

    &:focus {
        box-shadow: 0 0 0 4px hsla(20, 100%, 47%, 0.40);
    }

    &:active {
        background: #EA4C18;
    }

    @media screen and (max-width: 960px) {
        width: 300px;
    }

    @media screen and (max-width: 640px) {
        width: 100%;
    }

    @media screen and (max-width: 480px) {
        padding: 12px 0;
    }
`

// export const ButtonAction = styled.button`
//     padding: 18px 0;
//     width: 360px;

//     background: #FC531B;
//     border-radius: 12px;
//     border: none;

//     color: #FFFFFF;
//     font-style: normal;
//     font-weight: bold;
//     font-size: 24px;
//     line-height: 28px;
//     text-align: center;

//     transition: background .3s;
//     cursor: pointer;
//     z-index: 1;

//     &:hover {
//         background: #FF6D3D;
//     }

//     &:active {
//         background: #EA4C18;
//     }

//     @media screen and (max-width: 960px) {
//         width: 300px;
//     }

//     @media screen and (max-width: 640px) {
//         width: 100%;
//     }

//     @media screen and (max-width: 480px) {
//         padding: 12px 0;
//     }
// `


// ButtonsUpload
const ButtonWrapperCloud = styled.button.attrs({
    className: `app-button-wrapper cloud`
})``

const ButtonWrapper = styled.button.attrs({
    className: `app-button-wrapper`
})``

const ButtonTitle = styled.div.attrs({
    className: `app-button-title`
})``

const ButtonIcon = styled.img.attrs({
    className: 'app-button-icon'
})``



export const ButtonAddFiles = (props: {
    upload: TUpload,
    title?: string,
}) => {
    const ref = useRef<HTMLInputElement>(null)
    return (
        <ButtonWrapper
            title="Add Files"
            onClick={() => {
                if (!ref.current) throw Error("inputRef is not assigned");
                ref.current.click()
            }}
        >
            <ButtonIcon alt="Add Files Icon" src={addIcon} />
            <ButtonTitle>{props.title ? props.title : "Add Files"}</ButtonTitle>
            <input
                type="file"
                ref={ref}
                style={{ display: 'none' }}
                multiple={props.upload.multiselect}
                onChange={(e) => {
                    const files = e.target.files
                    if (files !== null) {
                        props.upload.clearErrors()
                        filesUpload({
                            files: files,
                            upload: props.upload,
                        })
                    }
                    e.target.value = ''
                }}
            />
        </ButtonWrapper>
    )
}

export const ButtonClearFiles = ({
    upload,
    title,
}: {
    upload: TUpload,
    title?: string,
}) => {
    return (
        <ButtonWrapper
            title="Reset"
            onClick={() => {
                if (confirm('Do you want clear file list?')) upload.clearFiles()
        }}>
            <ButtonIcon alt="Reset Icon" src={resetIcon} />
            <ButtonTitle>{title ? title : "Reset"}</ButtonTitle>
        </ButtonWrapper>
    )
}

// GoogleDrive
export const ButtonGoogleDrive = ({
    upload,
    title
}: TCloudButton) => {
    const scope = 'https://www.googleapis.com/auth/drive.readonly'
    const developerKey = "AIzaSyDgFV1Y95HDFI2RSBDme0qKLZcMoE5QRpE"
    const clientId = "773401989593-lln5k11l8espl9jhmi8908p5cn2dfphi.apps.googleusercontent.com"

    // const developerKey = "AIzaSyCPAVf1FiYbP5fmbqTu9omZh7oiu3h3ZCU"
    // const clientId = "741550181072-bpm6rmtop08qon8iuok7047i5kk3h6i3.apps.googleusercontent.com"

    const [oauthToken, setToken] = useState<string|undefined>(undefined)
    const [pickerLoaded, setPickerLoaded] = useState(false)

    // флаг для async функции предотвращабщий утечку памяти подписок для useEffect
    let creatingPicker: boolean = false

    const mimeMask = (extArr: TPossibleExtensions[]) => {
        const mimeArray: string[] = []
        extArr.map(ext => {
            const mime = getMimeFromExt(ext)
            if (!mime) return false
            if (mimeArray.indexOf(mime) === -1) mimeArray.push(mime)
        })
        return mimeArray.join(',')
    }

    function onPickerApiLoad() {
        setPickerLoaded(true);
    }

    function handleAuthResult(authResult: TGoogleAuthResult) {
        setToken(authResult.access_token)
    }

    function onAuthApiLoad() {
        window.gapi.auth.authorize(
            {
                'client_id': clientId,
                'scope': scope,
                'immediate': false
            },
            handleAuthResult
        );
    }

    function loadPicker() {
        window.gapi.load('auth', { 'callback': onAuthApiLoad });
        window.gapi.load('picker', { 'callback': onPickerApiLoad });
    }

    async function pickerCallback(response: any) {
        if (response.action === 'picked' && oauthToken) {
            gdriveUpload(upload, response.docs, oauthToken)
            if (creatingPicker) {
                setPickerLoaded(false)
                setToken(undefined)
            }
        }
        if (response.action === 'cancel') {
            if (creatingPicker) {
                setPickerLoaded(false)
                setToken(undefined)
            }
        }
    };

    useEffect(() => {
        if (pickerLoaded && oauthToken) {
            creatingPicker = true
            const createPicker = () => {
                var view = new window.google.picker.View(window.google.picker.ViewId.DOCS);
                view.setMimeTypes(mimeMask(upload.allowExtantions));

                var picker = new window.google.picker.PickerBuilder()
                    .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
                    .enableFeature(upload.multiselect
                        ? window.google.picker.Feature.MULTISELECT_ENABLED
                        : window.google.picker.Feature.MULTISELECT_DISABLED
                    )
                    .addView(view)
                    .setOAuthToken(oauthToken)
                    .setDeveloperKey(developerKey)
                    .setCallback(pickerCallback)
                    .build();

                picker.setVisible(true);
            }
            createPicker();
            return () => { creatingPicker = false }
        }
    }, [pickerLoaded, oauthToken])

    return (
        <ButtonWrapperCloud
            title="GoogleDrive"
            onClick={() => loadPicker()}
        >
            <ButtonIcon alt="GoogleDrive Icon" src={googledriveIcon} />
            <ButtonTitle>{title ? title : "GoogleDrive"}</ButtonTitle>
        </ButtonWrapperCloud>
    )
}

// OneDrive
export const ButtonOneDrive = ({
    upload,
    title
}: TCloudButton) => {
    const filter = "folder,." + upload.allowExtantions.join(",.")
    function launchOneDrivePicker() {
        var odOptions = {
            clientId: "b5e0f390-19ee-4cf6-af13-1ac4fc3a3315",
            action: "download",
            multiSelect: upload.multiselect,
            filter: filter,
            success: (files: TOneDriveResponse) => {
                onedriveUpload(upload, files);
            }
        }
        // @ts-ignore
        window.OneDrive.open(odOptions);
    }

    return (
        <ButtonWrapperCloud
            title="OneDrive"
            onClick={() => {
                // @ts-ignore
                if (window.OneDrive !== undefined) {
                    // @ts-ignore
                    launchOneDrivePicker();
                }
            }}
        >
            <ButtonIcon alt="OneDrive Icon" src={onedriveIcon} />
            <ButtonTitle>{title ? title : "OneDrive"}</ButtonTitle>
        </ButtonWrapperCloud>
    )
}

// DropBox
export const ButtonDropBox = ({
    upload,
    title
}: TCloudButton) => {
    const extensions = upload.allowExtantions.map(ext => '.' + ext)
    const sizeLimit = upload.maxSize * 1024 * 1024
    const options = {
        success: function (files: TDropBoxResponse) {
            dropboxUpload(upload, files)
        },
        sizeLimit: sizeLimit,
        multiselect: upload.multiselect,
        extensions: extensions,
        linkType: 'direct',
    };

    return (
        <ButtonWrapperCloud
            title="DropBox"
            onClick={() => {
                // @ts-ignore
                if (window.Dropbox !== undefined) {
                    // @ts-ignore
                    window.Dropbox.choose(options)
                }
            }}
        >
            <ButtonIcon alt="DropBox Icon" src={dropboxIcon} />
            <ButtonTitle>{title ? title : "DropBox"}</ButtonTitle>
        </ButtonWrapperCloud>
    )
}

